import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment } from 'react';
import PropTypes from 'prop-types';

const StepTabs = (
  {
    activeStep,
    steps,
    onClick
  }) => {
 

  return (
    <>
      <div className="step-tabs">
        <div className="steps">
          {steps.map((step, index) => (
            <Fragment key={index}>
              <div className={`step ${activeStep == index + 1 ? 'active' : activeStep > index + 1 ? 'completed' : ''}`}>
                <div className="circle" onClick={() => onClick(index + 1)}>{activeStep > index + 1 ? <FontAwesomeIcon icon={faCheck} /> : index + 1}</div>
                <p className='step-text w-100' dangerouslySetInnerHTML={{ __html: step.label }}></p>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`step-line ${activeStep > index + 1 ? 'completed' : ''
                  }`}
                ></div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

StepTabs.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array,
  onClick: PropTypes.func
};

export default StepTabs;